<template>
  <div class="package-detail">
    <!-- 自定义 Tab 导航 -->
    <div class="custom-tabs">
      <div class="tab-header">
        <div 
          v-for="tab in tabs" 
          :key="tab.name"
          :class="['tab-item', { 'active': activeTab === tab.name }]"
          @click="handleTabClick(tab.name)"
        >
          <span>{{ tab.label }} ({{ totalCounts[tab.name] }})</span>
        </div>
      </div>
    </div>

    <!-- 素材列表 -->
    <div class="material-list" v-loading="loading">
      <!-- 场景列表 -->
      <div v-if="activeTab === 'scene'" class="scene-list">
        <div class="package_detail_scene" v-for="item in currentList" :key="item.id">
          <div class="pic">
            <img v-if="!item.thumb" src="../HomePage/conver_scene_horizontal.png">
            <img class="item-img" v-if="item.thumb" :src="item.thumb">
          </div>
          <div class="name">{{ item.title }}</div>
          <div class="title">{{ item.copyright }}</div>
        </div>
      </div>

      <!-- 形象列表 -->
      <div v-if="activeTab === 'material'" class="material-list-content">
        <div class="package_detail_material" v-for="item in currentList" :key="item.id">
          <div class="pic">
            <img v-if="!item.thumb" src="../HomePage/conver_material_vertical.png">
            <img class="item-img" v-if="item.thumb" :src="item.thumb">
          </div>
          <div class="name">{{ item.title.length > 9 ? item.title.substring(0, 9) + '...' : item.title }}</div>
          <div class="title">{{ item.copyright }}</div>
        </div>
      </div>

      <!-- 道具列表 -->
      <div v-if="activeTab === 'prop'" class="prop-list">
        <div class="package_detail_prop" v-for="item in currentList" :key="item.id">
          <div class="pic">
            <img v-if="!item.thumb" src="../HomePage/conver_material_vertical.png">
            <img class="item-img" v-if="item.thumb" :src="item.thumb">
          </div>
          <div class="name">{{ item.title.length > 10 ? item.title.substring(0, 9) + '...' : item.title }}</div>
          <div class="title">{{ item.copyright }}</div>
        </div>
      </div>

      <!-- 背景音列表 -->
      <div v-if="activeTab === 'bgm'" class="bgm-list">
        <div class="package_detail_bgm" v-for="item in currentList" :key="item.id">
          <div class="pic">
            <img src="../HomePage/music.png">
          </div>
          <div class="name">{{ item.title.length > 10 ? item.title.substring(0, 9) + '...' : item.title }}</div>
          <div class="title">{{ item.copyright }}</div>
        </div>
      </div>

      <!-- 动作列表 -->
      <div v-if="activeTab === 'action'" class="action-list">
        <div class="package_detail_action" v-for="item in currentList" :key="item.id">
          <div>{{ item.title.length > 13 ? item.title.substring(0, 13) + '...' : item.title }}</div>
          <div v-if="item.extdata && item.extdata.movable !== null">
            <i class="icon-action_move" v-if="item.extdata.movable && item.extdata.looped"></i>
            <i class="icon-action_circulation" v-if="item.extdata.looped && !item.extdata.movable"></i>
            <i class="icon-action_time" v-if="!item.extdata.movable || !item.extdata.looped"></i>
            <span v-if="!item.extdata.movable || !item.extdata.looped">{{ item.extdata.duration.toFixed(2) }}秒</span>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="currentList.length === 0 && !loading" class="empty-state">
        <p>暂无{{ getTabName(activeTab) }}素材</p>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrapper" v-if="total > 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        size="small">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PackageDetail',
  props: {
    packageId: {
      type: [String, Number],
      required: true
    },
    token: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeTab: 'scene',
      loading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      currentList: [],
      totalCounts: {
        scene: 0,
        material: 0,
        prop: 0,
        bgm: 0,
        action: 0
      },
      tabs: [
        { name: 'scene', label: '场景' },
        { name: 'material', label: '形象' },
        { name: 'prop', label: '道具' },
        { name: 'bgm', label: '背景音' },
        { name: 'action', label: '动作' }
      ]
    }
  },
  mounted() {
    this.loadTabCounts()
    this.loadMaterialList()
  },
  watch: {
    packageId() {
      this.loadTabCounts()
      this.loadMaterialList()
    }
  },
  methods: {
    // 加载各个 tab 的总数
    async loadTabCounts() {
      const types = ['scene', 'material', 'prop', 'bgm', 'action']
      
      for (const type of types) {
        try {
          const response = await this.fetchMaterialList(type, 1, 1)
          this.totalCounts[type] = response.total || 0
        } catch (error) {
          console.error(`加载${type}总数失败:`, error)
          this.totalCounts[type] = 0
        }
      }
    },

    // 获取素材列表数据
    fetchMaterialList(type, page = 1, pageSize = 20) {
      const URL = `${process.env.HOST}/api/storage/market/packages/${this.packageId}/resources`
      const headers = {
        'Authorization': this.token
      }
      const params = {
        type: type,
        page: page,
        pageSize: pageSize
      }

      return new Promise((resolve, reject) => {
        this.AJAX.get(URL, headers, params).then(data => {
          if(data.code == 10000) {
            resolve({
              list: data.datas.rows || [],
              total: data.datas.total || 0
            })
          } else {
            reject(new Error(data.msg || '请求失败'))
          }
        }).catch(err => {
          this.$message({
            message: err.msg || '加载素材列表失败',
            type: "error"
          })
          reject(err)
        })
      })
    },

    // 加载当前 tab 的素材列表
    async loadMaterialList() {
      this.loading = true
      try {
        const response = await this.fetchMaterialList(this.activeTab, this.currentPage, this.pageSize)
        this.currentList = response.list
        this.total = response.total
      } catch (error) {
        console.error('加载素材列表失败:', error)
        this.$message({
          message: '加载素材列表失败',
          type: 'error'
        })
        this.currentList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    // Tab 切换
    handleTabClick(tabName) {
      this.activeTab = tabName
      this.currentPage = 1
      this.loadMaterialList()
    },

    // 分页大小改变
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.currentPage = 1
      this.loadMaterialList()
    },

    // 当前页改变
    handleCurrentChange(newPage) {
      this.currentPage = newPage
      this.loadMaterialList()
    },

    // 获取 tab 名称
    getTabName(tab) {
      const names = {
        scene: '场景',
        material: '形象',
        prop: '道具',
        bgm: '背景音',
        action: '动作'
      }
      return names[tab] || ''
    }
  }
}
</script>

<style scoped>
.package-detail {
  padding: 20px;
}
/* 自定义 Tab 样式 */
.custom-tabs {
  margin-bottom: 20px;
}

.tab-header {
  background: #2c3e50;
  border-radius: 8px;
  padding: 4px;
  border: 1px solid #34495e;
  display: flex;
  gap: 2px;
}

.tab-item {
  flex: 1;
  text-align: center;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  background: rgba(52, 73, 94, 0.6);
  transition: all 0.3s ease;
  cursor: pointer;
  user-select: none;
}

.tab-item:hover {
  background: rgba(52, 73, 94, 0.8);
  transform: translateY(-1px);
}

.tab-item.active {
  color: #ffffff;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  transform: translateY(-2px);
}

.tab-item span {
  color: inherit;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* 以下为原有其他样式，保持不变 */
.material-list {
  min-height: 300px;
  margin-bottom: 20px;
}
.scene-list,
.material-list-content,
.prop-list,
.bgm-list,
.action-list {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.package_detail_scene,
.package_detail_material,
.package_detail_prop,
.package_detail_bgm {
  width: 120px;
  text-align: center;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 10px;
  background: #fff;
  transition: all 0.3s;
}
.package_detail_scene:hover,
.package_detail_material:hover,
.package_detail_prop:hover,
.package_detail_bgm:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.package_detail_action {
  width: 200px;
  padding: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
  transition: all 0.3s;
}
.package_detail_action:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.pic {
  width: 100px;
  height: 60px;
  margin: 0 auto 8px;
  overflow: hidden;
  border-radius: 4px;
}
.pic img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.name {
  font-size: 14px;
  color: #303133;
  margin-bottom: 4px;
  font-weight: 500;
}
.title {
  font-size: 12px;
  color: #909399;
}
.empty-state {
  text-align: center;
  padding: 60px 0;
  color: #909399;
}
.pagination-wrapper {
  text-align: center;
  margin-top: 20px;
}
.icon-action_move,
.icon-action_circulation,
.icon-action_time {
  margin-right: 4px;
  font-size: 14px;
}
.icon-action_move {
  color: #67c23a;
}
.icon-action_circulation {
  color: #e6a23c;
}
.icon-action_time {
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// PackageDetail.vue?60962369